import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { initialSkeletonRowCount } from '@/components/modules/pages/mypage/client/Table/RfpClientTable/const';
import { RfpClientTableLarge } from '@/components/modules/pages/mypage/client/Table/RfpClientTable/RfpClientTableLarge';
import { RfpClientTableSmall } from '@/components/modules/pages/mypage/client/Table/RfpClientTable/RfpClientTableSmall';
import { Paginate } from '@/components/ui/Navigation/Paginate';
import { useLoadingPagination } from '@/hooks/ui/Navigation/useLoadingPagination';
export const RfpClientTable = (props) => {
    const { className = '', currentPage, loading = false, onPageChange: propOnPageChange, rows, totalRowCount, } = props;
    // 最大表示行数
    const maxRowCount = 8;
    // ページネーション ローディング表示制御
    const { onPageChange, prevItemCount } = useLoadingPagination({
        initialItemCount: initialSkeletonRowCount,
        itemCount: rows === null || rows === void 0 ? void 0 : rows.length,
        onPageChange: propOnPageChange,
    });
    return (_jsxs(_Fragment, { children: [_jsx(RfpClientTableLarge, { className: clsx('hidden md:table', className), loading: loading, rows: rows, skeletonRowCount: prevItemCount }), _jsx(RfpClientTableSmall, { className: clsx('table md:hidden', className), loading: loading, rows: rows, skeletonRowCount: prevItemCount }), loading ||
                (totalRowCount > 0 && (_jsx(Paginate, { className: clsx('justify-center md:justify-end', 'mt-20'), forcePage: currentPage - 1, onPageChange: onPageChange, pageCount: Math.ceil(totalRowCount / maxRowCount), pageRangeDisplayed: 5 })))] }));
};
